<template>
  <v-card>
    <v-toolbar color="primary" class="rounded-0 text-white" height="80px">
      <v-toolbar-title class="ml-3">
        <h2>Agent Yönetimi</h2>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-flex align-items-center">
        <!-- <v-icon
          color="error cursor-pointer"
          class="mr-2"
          dark
          :disabled="!isSelectable"
          @click="showDeleteAgentModal"
          v-permission="{
            permissions: ['agent-management'],
          }"
        >
          mdi-delete
        </v-icon> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="cursor-pointer"
              v-bind="attrs"
              dark
              @click="fetchAgents"
              v-on="on"
            >
              mdi-reload
            </v-icon>
          </template>
          <span>Yenile</span>
        </v-tooltip>
        <v-text-field
          v-model="search"
          label="Ara"
          dark
          class="mx-4 mt-0 pt-0"
          hide-details="auto"
          single-line
          append-icon="search"
        ></v-text-field>
        <CreateAgentModal @refresh="fetchAgents">
          <v-btn
            elevation="0"
            v-permission="{
              permissions: ['agent-management'],
            }"
            color="success"
            v-bind="$attrs"
            v-on="$listeners"
          >
            <v-icon small>mdi-plus</v-icon>
            Yeni Agent
          </v-btn>
        </CreateAgentModal>
      </div>
      <KTTopMenu></KTTopMenu>
    </v-toolbar>
    <v-card-text>
      <!-- Silme selectbox için v-model="selectedAgent" ve show-select data table a eklenmeli -->
      <v-data-table
        :headers="headers"
        :items="agents"
        :search="search"
        :single-select="true"
        sort-by="id"
        sort-desc="true"
        :items-per-page="100"
        :loading="loading"
        item-key="id"
      >
        <template #item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <router-link
                v-permission="{
                  permissions: ['agent-management'],
                }"
                :to="{
                  name: 'agent-management-edit',
                  params: { id: item.id },
                  query: { editable: true },
                }"
              >
                <v-icon color="warning" small v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </router-link>
            </template>
            <span>Görüntüle</span>
          </v-tooltip>
        </template>
        <template #item.name="{ item }">
          <router-link
            :to="{
              name: 'agent-management-edit',
              params: { id: item.id },
              query: { editable: false },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
        <template #item.phone="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span
                @mouseover="changeCursor"
                @mouseleave="resetCursor"
                @click="copyPhone(item.phone)"
                v-on="on"
              >
                {{ formatPhoneInput(item.phone) }}
              </span>
            </template>
            <span>Kopyala</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatPhoneInput } from "@/core/helper.js";
import {
  DELETE_AGENT,
  FETCH_AGENTS,
} from "@/core/services/store/agents.module";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import { mapActions, mapGetters } from "vuex";
import CreateAgentModal from "./CreateAgentModal.vue";

export default {
  name: "AgentManagementList",
  components: {
    KTTopMenu,
    CreateAgentModal,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "İsim", value: "name", align: "left" },
        {
          text: "Agent Şirket Numarası",
          value: "phone",
          align: "left",
        },
        {
          text: "Lead Sayısı",
          value: "lead_count",
          align: "left",
        },
        {
          text: "",
          value: "actions",
          align: "right",
          width: "100px",
          sortable: false,
        },
        //{ text: "", value: "data-table-select", align: "right" },
      ],
      //selectedAgent: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchAgents().then(() => (this.loading = false));
  },
  methods: {
    ...mapActions([FETCH_AGENTS, DELETE_AGENT]),
    formatPhoneInput,
    // async acceptDelete() {
    //   try {
    //     await this.deleteAgent(this.selectedAgent[0]);
    //     this.$toast.success("Agent silindi", {
    //       position: "bottom-right",
    //       duration: 2000,
    //     });
    //     this.selectedAgent = [];
    //   } catch (error) {
    //     const message =
    //       error[0].code === "QueryException"
    //         ? "Bu agent silinemez."
    //         : error[0].detail;
    //     this.$toast.error(message, {
    //       position: "bottom-right",
    //       duration: 2000,
    //     });
    //   }
    // },
    // showDeleteAgentModal() {
    //   const params = {
    //     title: "Seçtiğiniz agent silinecek",
    //     text: "Seçili agent'ı silmek istediğinize emin misiniz?",
    //     onConfirm: () => {
    //       return this.acceptDelete();
    //     },
    //   };
    //   this.$approvalModal.show(params);
    // },
    changeCursor() {
      document.querySelector("div").classList.add("cursor-pointer");
    },
    resetCursor() {
      document.querySelector("div").classList.remove("cursor-pointer");
    },
    copyPhone(phoneNumber) {
      let formattedPhoneNumber = phoneNumber.replace(/\D/g, "");
      navigator.clipboard.writeText(formattedPhoneNumber);
      this.$toast.info("Telefon numarası kopyalandı", {
        position: "bottom-right",
        duration: 1000,
      });
    },
  },
  computed: {
    ...mapGetters(["agents"]),
    // isSelectable() {
    //   return this.selectedAgent.length > 0;
    // },
  },
};
</script>

<style scoped></style>
